var _rect, _rect2, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCurrentbalance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 50,
    viewBox: "0 0 50 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 8,
    fill: "#666CFF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    width: 50,
    height: 50,
    rx: 8,
    fill: "white",
    fillOpacity: 0.88
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36 14H14C13.2707 14 12.5712 14.2897 12.0555 14.8055C11.5397 15.3212 11.25 16.0207 11.25 16.75V33.25C11.25 33.9793 11.5397 34.6788 12.0555 35.1945C12.5712 35.7103 13.2707 36 14 36H36C36.7293 36 37.4288 35.7103 37.9445 35.1945C38.4603 34.6788 38.75 33.9793 38.75 33.25V16.75C38.75 16.0207 38.4603 15.3212 37.9445 14.8055C37.4288 14.2897 36.7293 14 36 14ZM36 23.625H14V19.5H36V23.625Z",
    fill: "#666CFF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCurrentbalance);
export default __webpack_public_path__ + "static/media/currentbalance.015a79bba2ffd21a55ac28c5bf34e9d9.svg";
export { ForwardRef as ReactComponent };